module.exports = __webpack_public_path__ + "static/img/bander01.3adc12a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/bander01.jpg
// module id = 89jk
// module chunks = 0